import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { closeDialog, displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { FAQCloseConfirmationContentProps } from "models/propTypes/supportPropTypes";
//#endregion
//#region components
import { ActionLinkButton, Icon } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const FAQCloseConfirmationContent: React.FC<FAQCloseConfirmationContentProps> = (props) => {
  const { supportTicketDialog } = props;
  const dispatch = useDispatch();

  const onCreateSupportClick = () => {
    dispatch(closeDialog());
    props.onCreateSupportClick();

    setTimeout(() => {
      dispatch(displayDialog(supportTicketDialog));
    });
  };

  return (
    <>
      <p>{LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.UnansweredQuestionText)}</p>
      <ActionLinkButton
        onClick={onCreateSupportClick}
        endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} />}
      >
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.CreateSupportCaseText)}
      </ActionLinkButton>
    </>
  );
};

export default FAQCloseConfirmationContent;
